import React from "react";

const RemoveFilterIcon = () => (

<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="1.0-Broker---Referrals-&amp;-Closes---Current" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.3-Broker-Portal---Referrals---Apply-Filter" transform="translate(-96.000000, -192.000000)" fill="#B4B3B3" fillRule="nonzero">
            <path d="M104,208 C108.416667,208 112,204.416667 112,200 C112,195.583333 108.416667,192 104,192 C99.5833333,192 96,195.583333 96,200 C96,204.416667 99.5833333,208 104,208 Z M108,201.333333 L100,201.333333 C99.6354167,201.333333 99.3333333,201.03125 99.3333333,200.666667 L99.3333333,199.333333 C99.3333333,198.96875 99.6354167,198.666667 100,198.666667 L108,198.666667 C108.364583,198.666667 108.666667,198.96875 108.666667,199.333333 L108.666667,200.666667 C108.666667,201.03125 108.364583,201.333333 108,201.333333 Z" id="icon-remove"></path>
        </g>
    </g>
</svg>)

export default RemoveFilterIcon
